module.exports = __webpack_public_path__ + "img/news-white.f59e9fc6.svg";